import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const FinancialProcessAutomation = () => {
  const serviceData = {
    title: "Finance Process Automation",
    heading: "Finance Process Automation",
    image: subTopicImages["Financial Process Automation"],
    intro: "Modern finance teams need efficient, technology-driven processes.",
    description: [
      "We help organisations digitise and streamline their finance workflows.",
    ],
    services: [
      {
        title: "Process Automation & Digitisation",
        text: "Our services include:",
        list: [
          "standardising finance and accounting processes",
          "assistance in ERP / accounting software implementation",
          "automation of recurring tasks",
          "development of internal controls and approval systems",
          "data integrity and reporting governance",
        ],
        extraInfo:
          "Automation reduces manual dependence, improves controls and ensures faster, more accurate financial operations.",
      },
    ],
    benefitsIntro: "",
    benefits: [
      "We help you move from spreadsheets to smart, system-driven finance operations.",
    ],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default FinancialProcessAutomation;
